"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckedAttributes = exports.CheckedAttributesProvider = exports.CheckedAttributesContext = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const checked_attributes_utils_1 = require("./checked-attributes.utils");
const utils_1 = require("../../utils");
const localization_1 = require("../../../localization");
exports.CheckedAttributesContext = react_1.default.createContext({
    checkedIds: [],
    isAttributeCheckMode: false,
    isValueCheckMode: false,
    checkedItemTypeTitle: '',
    correspondingAttributeInValueCheckMode: '',
    getCheckedEntityLabels: () => null,
    checkIfAttributeValuePairChecked: () => false,
    getCheckedAttributeValuePair: () => null,
    onCheck: ramda_1.identity,
    clearCheckedIds: () => null,
    getCheckedAttributeValuesMap: () => ({}),
});
const CheckedAttributesProvider = ({ children }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [checkedAttributeValuePairs, setCheckedAttributeValuePairs] = (0, react_1.useState)([]);
    const onCheck = (0, react_1.useCallback)((item, isChecked) => {
        const checkedItem = (0, checked_attributes_utils_1.createCheckedItem)(item);
        setCheckedAttributeValuePairs((0, utils_1.updateUniqueItemListBasedOnValue)(checkedItem, isChecked));
    }, []);
    const clearCheckedIds = (0, react_1.useCallback)(() => {
        setCheckedAttributeValuePairs([]);
    }, []);
    const isAttributeCheckMode = !!checkedAttributeValuePairs.length && (0, checked_attributes_utils_1.isAttributeChecked)(checkedAttributeValuePairs[0]);
    const isValueCheckMode = !!checkedAttributeValuePairs.length && !isAttributeCheckMode;
    const checkedItemTypeTitle = String(isAttributeCheckMode ? t({ key: 'ATTRIBUTE' }) : t({ key: 'VALUE' })).toLowerCase();
    const getCheckedAttributeValuesMap = (0, react_1.useCallback)(() => {
        if (!checkedAttributeValuePairs.length) {
            return null;
        }
        const attributeValuesMap = {};
        checkedAttributeValuePairs.forEach((item) => {
            const [attribute, value] = (0, checked_attributes_utils_1.getCheckedAttributeValuePair)(item);
            if (!attributeValuesMap[attribute]) {
                attributeValuesMap[attribute] = [];
            }
            if (value) {
                attributeValuesMap[attribute].push(value);
            }
        });
        return attributeValuesMap;
    }, [checkedAttributeValuePairs]);
    const checkIfAttributeValuePairChecked = (item) => checkedAttributeValuePairs.includes((0, checked_attributes_utils_1.createCheckedItem)(item));
    const getCheckedEntityLabels = (0, react_1.useCallback)(() => {
        const entityIndex = isValueCheckMode ? 1 : 0;
        return checkedAttributeValuePairs.map((item) => (0, checked_attributes_utils_1.getCheckedAttributeValuePair)(item)[entityIndex]);
    }, [checkedAttributeValuePairs, isValueCheckMode]);
    const correspondingAttributeInValueCheckMode = (0, react_1.useMemo)(() => {
        if (!isValueCheckMode) {
            return '';
        }
        return (0, checked_attributes_utils_1.getCheckedAttributeValuePair)(checkedAttributeValuePairs[0])[0];
    }, [checkedAttributeValuePairs, isValueCheckMode]);
    return (react_1.default.createElement(exports.CheckedAttributesContext.Provider, { value: {
            checkedIds: checkedAttributeValuePairs,
            isAttributeCheckMode,
            isValueCheckMode,
            checkedItemTypeTitle,
            correspondingAttributeInValueCheckMode,
            getCheckedEntityLabels,
            checkIfAttributeValuePairChecked,
            getCheckedAttributeValuePair: checked_attributes_utils_1.getCheckedAttributeValuePair,
            clearCheckedIds,
            onCheck,
            getCheckedAttributeValuesMap,
        } }, children));
};
exports.CheckedAttributesProvider = CheckedAttributesProvider;
const useCheckedAttributes = () => (0, react_1.useContext)(exports.CheckedAttributesContext);
exports.useCheckedAttributes = useCheckedAttributes;
exports.default = exports.CheckedAttributesProvider;
